import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { motion } from "framer-motion";
import { api } from "@/lib/marketplace";
import { ListingCard } from "@/pages/Marketplace";

export default function FeaturedListings() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const r = await api.listListings({ sort: "newest", page_size: 8 });
        setItems(r.items || []);
      } catch { setItems([]); }
      finally { setLoading(false); }
    })();
  }, []);

  // Hide section entirely if no listings yet (keeps homepage clean before seed data)
  if (!loading && items.length === 0) return null;

  return (
    <section id="marketplace-featured" data-testid="featured-listings" className="relative py-24 md:py-32 bg-[#0D0F12]">
      <div className="absolute inset-0 grid-bg opacity-10" />
      <div className="relative max-w-[1400px] mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-10"
        >
          <div>
            <span className="text-xs font-mono tracking-[0.3em] uppercase text-[#00cccc]">// Marketplace</span>
            <h2 className="mt-4 text-4xl sm:text-5xl lg:text-6xl font-black tracking-tight leading-tight">
              Featured <span className="text-gradient-cyan">Motorcycles.</span>
            </h2>
            <p className="mt-3 text-zinc-400 text-base max-w-xl">Hand-picked pre-owned bikes from our rider community.</p>
          </div>
          <Link to="/marketplace" data-testid="view-all-bikes" className="group inline-flex items-center gap-2 px-5 py-3 rounded-full border border-[#00cccc]/40 text-[#00cccc] hover:bg-[#00cccc] hover:text-black transition-all text-sm">
            View All Bikes <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
          </Link>
        </motion.div>

        {loading ? (
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
            {Array.from({ length: 4 }).map((_, i) => (
              <div key={i} className="aspect-[4/3] rounded-xl bg-white/[0.04] border border-white/10 animate-pulse" />
            ))}
          </div>
        ) : (
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
            {items.slice(0, 8).map((it) => <ListingCard key={it.listing_id} item={it} compact />)}
          </div>
        )}
      </div>
    </section>
  );
}
